import axios from '../services/axios';

export async function getEstimatedOrderTime(companyId) {
    try{
        const res = await axios.get(`/smartmenu/order/estimated-time?companyId=${companyId}`);

        return res.data;

    } catch (error) {
        throw error;
    }
}